import React from 'react';
import {IonButton, IonIcon, IonSpinner} from "@ionic/react";
import {save} from "ionicons/icons";

interface SaveButtonProps {
  onClick: () => void;
  loading: boolean;
  label?: string;
}

const SaveButton: React.FC<SaveButtonProps> = (props) => {
  const {onClick, loading} = props;
  const label = props.label || 'Gravar';

  return (
    <div>
      <IonButton
        onClick={onClick}
        disabled={loading}
      >
        {
          loading ?
            <IonSpinner slot="start" className="mr-2"/> :
            <IonIcon icon={save} slot="start"/>
        }
        {label}
      </IonButton>
    </div>
  );
}

export default SaveButton;
